import { GET_LIST_COUNTRY_SUCCESS, SEARCH_COUNTRY } from '../actions/getListCountry';

const initState = {
    listCountry: [],
    searchCountry: []
}

export default (state = initState, action) => {
    switch (action.type) {
        case GET_LIST_COUNTRY_SUCCESS:
            return {
                listCountry: action.payload.data.data,
                searchCountry: action.payload.data.data,
            }

        case SEARCH_COUNTRY:
            return {
                ...state,
                searchCountry: action.payload,
            }

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/getListCountry.js